import { consoleErrorPackagesSdk } from "../../utils/consoleErrorPackagesSdk";
import { removeNullKeys } from "./removeNullKeys";

const URL_BRANCH_STANDARD_EVENT = "https://api2.branch.io/v2/event/standard";

export type BranchPurchaseEventProps = {
  contentType?: string | null;
  currency?: string | null;
  developerIdentity?: string | null;
  language?: string | null;
  price?: number | null;
  revenue?: number | null;
  screenHeight?: number | null;
  screenWidth?: number | null;
  source?: string | null;
  userAgent?: string | null;
};

const getAmount = (amount?: number | null) =>
  amount == null ? null : amount.toString();

export const getBranchPurchaseEvent = ({
  contentType,
  currency,
  developerIdentity,
  language,
  price,
  revenue,
  screenHeight,
  screenWidth,
  source,
  userAgent,
}: BranchPurchaseEventProps) => ({
  branch_key:
    process.env.NEXT_PUBLIC_BRANCH_KEY ?? process.env.DOPPLER_PUBLIC_BRANCH_KEY,
  name: "PURCHASE",
  user_data: removeNullKeys({
    // Branch rejects a non-mobile request carrying no identifier at all
    developer_identity: developerIdentity,
    language,
    screen_height: screenHeight,
    screen_width: screenWidth,
    user_agent: userAgent,
  }),
  event_data: removeNullKeys({ currency, revenue }),
  custom_data: removeNullKeys({
    "Content Type": contentType,
    Currency: currency,
    Price: getAmount(price),
    Revenue: getAmount(revenue),
    Source: source,
  }),
});

export const trackBranchPurchase = async (props: BranchPurchaseEventProps) => {
  const event = getBranchPurchaseEvent(props);
  const heading = "trackBranchPurchase";
  if (!event.branch_key)
    return consoleErrorPackagesSdk({ error: "missing Branch key", heading });
  try {
    const response = await fetch(URL_BRANCH_STANDARD_EVENT, {
      body: JSON.stringify(event),
      // checkout replaces the page as soon as the purchase is tracked
      keepalive: true,
      method: "POST",
    });
    if (!response.ok)
      consoleErrorPackagesSdk({ error: `${response.status}`, heading });
  } catch (error) {
    consoleErrorPackagesSdk({ error: `${error}`, heading });
  }
};
